/*
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * All rights reserved
 * mailto:info AT sonarsource DOT com
 */

export default function JiraIcon() {
  return (
    <svg height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.4152 1H7.67347C7.67347 1.80713 7.99411 2.58121 8.56484 3.15194C9.13557 3.72267 9.90964 4.0433 10.7168 4.0433H11.9587V5.24237C11.9598 6.92161 13.3208 8.28266 15 8.28376V1.58484C15 1.26193 14.7382 1 14.4152 1Z"
        fill="currentColor"
      />
      <path
        d="M11.0794 4.35914H4.33775C4.33879 6.03837 5.69978 7.39942 7.37908 7.40052H8.62098V8.60343C8.62311 10.2827 9.98504 11.6428 11.6643 11.6428V4.94409C11.6643 4.62107 11.4024 4.35914 11.0794 4.35914Z"
        fill="currentColor"
      />
      <path
        d="M7.74168 7.71635H1C1 9.39713 2.36258 10.7597 4.0433 10.7597H5.28909V11.9587C5.29019 13.6364 6.64882 14.9968 8.32658 15V8.30125C8.32658 7.97823 8.0647 7.71635 7.74168 7.71635Z"
        fill="currentColor"
      />
    </svg>
  );
}
